<template>
  <div class="Content">
    <div class="bar" :id="echartsId"></div>
  </div>
</template>
<script>
import { getSlice } from "@/utils/index";
import { isNull, isUndefined } from "util";
import * as utils from "@/utils/index.js";
import dateTool from "@/utils/dateTool";
import * as fpg from "@/utils/fpg.js";
import uuidv1 from "uuid/v1";
export default {
  name: "Bar",
  props: {
    barDate1: {
      //echarts数据
      type: Object, //类型对象
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      myChart: null,
      objdata: "",
      fromDate: "",
      toDate: "",
      echartsId: uuidv1(),
    };
  },
  created() {},
  watch: {
    barDate1(newVal, oldVal) {
      this.objdata = this.initData(newVal);
      this.fillYearEcharts(this.objdata);
    },
  },
  mounted() {
    this.objdata = this.initData(this.barDate1);
    this.fillYearEcharts(this.objdata);
  },
  methods: {
    initData(curval) {
      let obj = {
        barDatedd: curval.barDatedd,
        barDatedd1: curval.barDatedd1,
        measureId: curval.measureId,
        dateType: curval.dateType,
        x: curval.xdata,
        type: curval.type,
        time: curval.time,
        series: [
          {
            name: "峰期电量(kWh)",
            type: "bar",
            data: curval.seriesData[0],
            stack: "电量",
          },
          {
            name: "平期电量(kWh)",
            type: "bar",
            data: curval.seriesData[1],
            stack: "电量",
          },
          {
            name: "谷期电量(kWh)",
            type: "bar",
            data: curval.seriesData[2],
            stack: "电量",
          },
          {
            name: "累计用电(kWh)",
            type: "line",
            data: curval.seriesData[3],
            symbol: "circle",
            showAllSymbol: true,
            symbolSize: 8,
          },
        ],
      };
      return obj;
    },
    fillYearEcharts(obj) {
      let this_ = this;
      if (
        this_.myChart != null &&
        this_.myChart != "" &&
        this_.myChart != undefined
      ) {
        this_.myChart.dispose();
      }
      this.myChart = this.$echarts.init(
        document.getElementById(this.echartsId)
      );
      var option = {
        tooltip: {
          trigger: "axis",
          confine: true,
        },
        color: ["#d4953e", "#78b1e9", "#6ea562", "#e8855b", "#DC143C"],
        grid: {
          left: "3%",
          right: "5%",
          bottom: "13%",
          top: "15%",
          show: true,
          borderColor: "#dce1e7",
          containLabel: true,
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
          },
        },
        legend: {
          data: [
            "峰期电量(kWh)",
            "平期电量(kWh)",
            "谷期电量(kWh)",
            "累计用电(kWh)",
          ],
          top: "5%",
          textStyle: {
            color: "#666",
          },
        },
        xAxis: [
          {
            type: "category",
            data: obj.x,
            axisLabel: {
              color: "#666",
              fontSize: 10,
              fontFamily: "FZLTHJW",
              interval: 0,
              rotate: -30,
            },
          },
        ],
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "92%",
            left: "center",
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#666",
            },
          },
        ],
        series: obj.series,
      };
      this_.myChart.setOption(option, true);
      if (this_.myChart) {
        window.addEventListener("resize", function() {
          this_.myChart.resize();
        });
      }
      //点击事件
      this_.myChart.on("click", function(params) {
        if (obj.type == "df") {
          return;
        }
        let startTime = obj.time[params.dataIndex];
        if (obj.barDatedd.dateType == "month") {
          startTime = new Date(startTime.time);
          startTime.setDate(params.dataIndex + 1);
          let startTime1 =
            dateTool.format(new Date(startTime), "yyyy-MM-dd") + " 00:00:00";
          let toTime = new Date(startTime1);
          toTime.setDate(params.dataIndex + 2);
          let endTime =
            dateTool.format(new Date(toTime), "yyyy-MM-dd") + " 00:00:00";

          this_.fromDate = startTime1;
          this_.toDate = endTime;
          let timeData = JSON.parse(
            JSON.stringify(fpg.getMatchTime(this_.fromDate, this_.toDate, "0"))
          ); //匹配查询时间
          obj.barDatedd1.seriesData = [
            { time: [] },
            { time: [] },
            { time: [] },
            { time: [] },
          ];
          obj.barDatedd1.seriesData[0].time = JSON.parse(
            JSON.stringify(timeData)
          );
          obj.barDatedd1.seriesData[1].time = JSON.parse(
            JSON.stringify(timeData)
          );
          obj.barDatedd1.seriesData[2].time = JSON.parse(
            JSON.stringify(timeData)
          );
          obj.barDatedd1.seriesData[3].time = JSON.parse(
            JSON.stringify(timeData)
          );

          this_.$api.cost
            .getSpentMoneyHour(
              obj.measureId,
              startTime1,
              endTime,
              "100229",
              "0",
              1,
              ""
            )
            .then((res) => {
              //  if(vm.elem.dateType=='2'){
              fpg.getEcharts(res.data, "bar");
              obj.barDatedd.timeTitle =
                new Date(startTime1).getDate() + "日峰平谷情况";
              obj.barDatedd1.seriesData[0].time = fpg.timeChabge1(
                obj.barDatedd1.seriesData[0].time,
                res.data,
                "f"
              ); //转换峰数据  拿当前月的
              obj.barDatedd1.seriesData[1].time = fpg.timeChabge1(
                obj.barDatedd1.seriesData[1].time,
                res.data,
                "p"
              ); //转换平数据
              obj.barDatedd1.seriesData[2].time = fpg.timeChabge1(
                obj.barDatedd1.seriesData[2].time,
                res.data,
                "g"
              ); //转换谷数据
              obj.barDatedd1.seriesData[3].time = fpg.timeChabge1(
                obj.barDatedd1.seriesData[3].time,
                res.data,
                "total"
              ); //转换谷数据
              obj.barDatedd.seriesData = [[], [], [], []];
              for (let i = 0; i < obj.barDatedd1.seriesData.length; i++) {
                for (
                  let j = 0;
                  j < obj.barDatedd1.seriesData[i].time.length - 1;
                  j++
                ) {
                  obj.barDatedd.seriesData[i].push(
                    obj.barDatedd1.seriesData[i].time[j].value
                  );
                }
              }

              this_.bus.$emit("barChartClick", obj.barDatedd);
            });
        } else {
          startTime = new Date(startTime.time);
          startTime.setMonth(params.dataIndex);
          let startTime1 =
            dateTool.format(new Date(startTime), "yyyy-MM") + "-01 00:00:00";
          let toTime = new Date(startTime1);
          toTime.setMonth(params.dataIndex + 1);
          let endTime =
            dateTool.format(new Date(toTime), "yyyy-MM") + "-01 00:00:00";
          this_.fromDate = startTime1;
          this_.toDate = endTime;
          let timeData = JSON.parse(
            JSON.stringify(fpg.getMatchTime(this_.fromDate, this_.toDate, "2"))
          ); //匹配查询时间
          obj.barDatedd1.seriesData = [
            { time: [] },
            { time: [] },
            { time: [] },
            { time: [] },
          ];

          let hindex = new Date(startTime1).getMonth() + 1;
          obj.barDatedd.timeTitle = hindex + "月峰平谷情况";
          obj.barDatedd1.seriesData[0].time = JSON.parse(
            JSON.stringify(timeData)
          );
          obj.barDatedd1.seriesData[1].time = JSON.parse(
            JSON.stringify(timeData)
          );
          obj.barDatedd1.seriesData[2].time = JSON.parse(
            JSON.stringify(timeData)
          );
          obj.barDatedd1.seriesData[3].time = JSON.parse(
            JSON.stringify(timeData)
          );
          this_.$api.cost
            .getSpentMoneyDay(
              obj.measureId,
              startTime1,
              endTime,
              "100229",
              "0",
              1,
              ""
            )
            .then((res) => {
              fpg.getEcharts(res.data[0], "bar");
              obj.barDatedd1.seriesData[0].time = fpg.timeChabge1(
                obj.barDatedd1.seriesData[0].time,
                res.data[0],
                "f"
              ); //转换峰数据  拿当前月的
              obj.barDatedd1.seriesData[1].time = fpg.timeChabge1(
                obj.barDatedd1.seriesData[1].time,
                res.data[0],
                "p"
              ); //转换平数据
              obj.barDatedd1.seriesData[2].time = fpg.timeChabge1(
                obj.barDatedd1.seriesData[2].time,
                res.data[0],
                "g"
              ); //转换谷数据
              obj.barDatedd1.seriesData[3].time = fpg.timeChabge1(
                obj.barDatedd1.seriesData[3].time,
                res.data[0],
                "total"
              ); //转换谷数据
              obj.barDatedd.seriesData = [[], [], [], []];
              for (let i = 0; i < obj.barDatedd1.seriesData.length; i++) {
                for (
                  let j = 0;
                  j < obj.barDatedd1.seriesData[i].time.length - 1;
                  j++
                ) {
                  obj.barDatedd.seriesData[i].push(
                    obj.barDatedd1.seriesData[i].time[j].value
                  );
                }
              }

              this_.bus.$emit("barChartClick", obj.barDatedd);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.pagebox {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.bar {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.Content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid #ccd7e8;
  border-radius: 10px;
}
.count {
  position: absolute;
  top: 2rem;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0 0 10px 2px #ccd7e8;
  box-sizing: border-box;
}
.countUl {
  list-style: none;
  overflow: hidden;
  display: flex;
  margin-left: 5%;
  margin: 0px;
  height: 20px;
  margin-top: 11px;
  padding-left: 26px;
}
.countUl li {
  font-size: 0.1rem;
  line-height: 1.2rem;
  box-sizing: border-box;
  margin-right: 10px;
  text-align: center;
  width: 100px;
}
.parentflex {
  position: relative;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
  padding-top: 1px;
}
.parentflex > p {
  width: 100%;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 1.2rem;
  padding-left: 1rem;
  font-weight: bold;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.content {
  position: absolute;
  top: 35px;
  bottom: 5px;
  left: 5px;
  right: 5px;
}
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  padding-top: 1px;
}
canvas {
  height: 100%;
}
</style>
